import { render, staticRenderFns } from "./JournalMaterialRequestView.vue?vue&type=template&id=77c5849c"
import script from "./JournalMaterialRequestView.vue?vue&type=script&lang=js"
export * from "./JournalMaterialRequestView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports